import React from 'react';
import { cn } from '../../lib/utils';

export const LoadingSpinner = ({ className, size = 'md', label }) => {
  const sizeMap = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center h-64', className)} data-testid="loading-spinner">
      <div className={cn('animate-spin rounded-full border-b-2 border-[#1db584]', sizeMap[size])} />
      {label && <p className="text-sm text-gray-500 mt-3">{label}</p>}
    </div>
  );
};

export default LoadingSpinner;
